<template>
    <TotemSelect
        :options="orders"
        :placeholder="this.sortingLabel"
        ref="sortingSelect"
        type="sorting"
        :clearable="false"
        @input="onSortChange"
        :reduce="({ type, order }) => ({ type, order })"
        :value="currentSort"
        class="sorter"
        showSelectedOption
        :width="290"
    />
</template>

<script>
    import { mapGetters } from 'vuex'
    import { getOrderTypeOptions } from 'store/shared/sorterOptions'

    export default {
        name: 'Sorter',
        computed: {
            ...mapGetters({
                currentSort: 'Search/getCurrentSort'
            }),
            sortingLabel () {
                return this.$t('CourseListFilter.sort')
            },
            orders () {
                return getOrderTypeOptions()
            }
        },
        methods: {
            onSortChange (sort) {
                this.$store.dispatch('Search/setSort', sort)
            }
        }
    }
</script>

<style scoped>
    .sorter {
        [class*="desktop"] & {
            margin: 0 10px 0 auto;
        }
    }
</style>
